import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import Reveal from '../components/ui/Reveal';
import usePage from '../hooks/usePage';

const DEFAULT_CONTENT =
  "<p>Students' education is curated to establish a path to success and futuristic opportunities at St. Andrews World School, Indirapuram. Learning to code and having an in-depth knowledge of technology and how it operates will prove beneficial for the students. The future is technology and being in synchronization with the latest tech and the tech language will give our students a competitive advantage. Moreover, coding also helps the students to improve problem-solving skills and results in academic success. Learning coding and programming skills from a young age can help students have a better understanding of the digital world and how it operates.</p>";

const ExposureCodingPage = () => {
  const pageData = usePage('exposure-to-programming-and-coding-languages', { content: DEFAULT_CONTENT });

  const title = 'Exposure to Programming and Coding Languages';

  return (
    <>
      <SEO title={title} description="Exposure to programming and coding languages at SAWS Indirapuram." keywords="coding, programming, exposure, SAWS Indirapuram" />

      <section className="page-hero">
        {!pageData.loading && <img src={pageData.bannerImage || '${process.env.PUBLIC_URL}/images/page-banners/curricullam-infrastructure.jpg'} alt={title} className="page-hero-img" loading="eager" />}
        <div className="page-hero-content">
          <div className="container">
            <div className="page-hero-inner">

            </div>
          </div>
        </div>
      </section>

      <section className="content-page">
        <div className="container">
          <div className="card p-7 md:p-10 max-w-[1000px] mx-auto">
            <div className="text-body leading-relaxed" dangerouslySetInnerHTML={{ __html: pageData.content || DEFAULT_CONTENT }} />
          </div>
        </div>
      </section>
    </>
  );
};

export default ExposureCodingPage;